import every from 'lodash/every';
import filter from 'lodash/filter';
import some from 'lodash/some';
import {createSelector} from 'reselect';

import {FEATURE_SOURCE_ALL} from '../config';
import eventPredicateFactories from '../filters/event-predicates';

const getAppState = (state) => state.app;
const getFeatureSource = (state) => state.featureSources[FEATURE_SOURCE_ALL];

function mapFeature(eventPredicates, feature) {
	return {
		...feature,
		properties: {
			...feature.properties,
			isActive:
				feature.properties &&
				feature.properties.events &&
				every(eventPredicates, (predicate) =>
					some(feature.properties.events, predicate)
				),
		},
	};
}

export default createSelector(
	[getFeatureSource, getAppState],
	(featureSource, appState) => {
		const eventPredicates = filter(
			eventPredicateFactories.map((factory) => factory(appState))
		);

		return {
			...featureSource,
			lastUpdate: Date.now(),

			data: featureSource.data && {
				...featureSource.data,
				features:
					(featureSource.data.features &&
						featureSource.data.features.map((feature) =>
							mapFeature(eventPredicates, feature)
						)) ||
					[],
			},
		};
	}
);
